import { gql } from 'urql';

export const needsBasedQuestionsQuery = gql`
	query needsBasedQuestionnaire($questionnaireId: String!, $language: NonEmptyString! = "en-us") {
		questionnaire(questionnaireId: $questionnaireId, options: { language: $language }) {
			questions {
				questionId
				description
				order
				answer {
					__typename
					... on HasPredefinedAnswer {
						answers {
							answerId
							description
						}
						... on HasAnswerFormat {
							format
						}
					}
				}
				answerRequired
				triggers {
					questionId
					answerId
				}
			}
		}
	}
`;
